module.exports = __webpack_public_path__ + "ipotechnaya_kvartira.5a85e04f0b9973b399f2cb6bb50933b3.jpg";